module.exports = __webpack_public_path__ + "static/media/corkease-1.046f6924.jpg";